import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

/**
 * Ovladaci prvky do mapy v galerii
 */
export default class ControlBestfit {
	_node: HTMLDivElement;

	_btn: HTMLButtonElement;

	constructor({
		onBestFit = () => {},
	}: {
		onBestFit: () => void;
	}) {
		this._node = node("div", { className: "control-bestfit map-control" });
		this._btn = node("button", { className: "icon bestfit", title: _("gallery.bestfit") });
		this._btn.setAttribute("data-log-ignore", "1");
		this._btn.appendChild(icon("bestfit"));
		this._btn.addEventListener("click", () => {
			onBestFit();
		});
		this._node.appendChild(this._btn);
	}

	destroy() {
		Mapy.Util.clear(this._node);
	}

	getContainer() {
		return this._node;
	}

	set show(show: boolean) {
		if (show) {
			this._node.classList.remove("hide");
		} else {
			this._node.classList.add("hide");
		}
	}
}
